export enum TranslatePagePath {
  UM = 'users-management',
  UMUsers = 'users-management/users',
  UMRoles = 'users-management/roles',
  Organization = 'organization',
  PolicyList = 'lists',
  Overall = 'overall',
  OverallCA = 'overall/columnsAliases',
  Entity = 'entity',
  Policies = 'policies',
  EditTF = 'policies/edit-trigger-form',
  EditSF = 'policies/edit-signal-form',
  EditVF = 'policies/edit-variable-form',
  VariableQF = 'policies/variable-queries-form',
  Triggers = 'policies/triggers',
  Signals = 'policies/signals',
  Variables = 'policies/variables',
}

export enum TranslatePageModuleName {
  UM = 'um',
  UMUsers = 'users',
  UMRoles = 'rolesPage',
  Organization = 'organization',
  PolicyList = 'policyList',
  Overall = 'overall',
  OverallCA = 'columnsAliases',
  Entity = 'network-graph',
  Policies = 'policies',
  EditTF = 'edit-trigger-form',
  EditSF = 'edit-signal-form',
  EditVF = 'edit-variable-form',
  VariableQF = 'variable-queries-form',
  Triggers = 'triggers',
  Signals = 'signals',
  Variables = 'variables',
}
